import React from "react";
import { BrowserRouter, Switch, Redirect, Route, Link, NavLink } from "react-router-dom";

import { Header } from '../../Components/Layout/Header.jsx'
import { GameDetails } from '../../Components/Game/GameDetails.jsx'
import { ObavijestiCasino } from '../../Components/Layout/ObavijestiCasino.jsx'
import { Game } from '../../Components/Game/Game.jsx'

import { Banners } from '../../Components/Banner/Banners.jsx'
import { MojCasino } from '../../Components/Casino/MojCasino.jsx'
import { BonusItem } from '../../Components/Bonuses/BonusItem.jsx'
import { MaratonPobjednici } from '../../Components/Casino/MaratonPobjednici.jsx'


import { MaratonHappyHour } from '../../Components/Casino/MaratonHappyHour.jsx'
import { MaratonHappyHourPobjednici } from '../../Components/Casino/MaratonHappyHourPobjednici.jsx'

import { LastManStanding } from '../../Components/Casino/LastManStanding.jsx'
import { MetaTags } from '../../Components/Layout/MetaTags.jsx'


export class ReloadBonus extends React.Component {
  constructor(props) {
    super(props);
    this.state = { tabs: ['Casino Reload Bonus', 'Bodovanje'], selectedTab: null };

    this.gotoTab = this.gotoTab.bind(this);
  }

  componentDidMount() {
    window.scrollTo(0, 0);
    this.props.showMenuFn(false);
    this.gotoTab(this.state.tabs[0]);
  }

  gotoTab(tab) {
    this.setState({ selectedTab: tab });
  }

  getTime(end, active) {
    var delta = (new Date(end) - new Date()) / 1000;

    if (delta < 0 || !active)
      return "Završeno";

    var dana = Math.floor(delta / 86400);
    delta -= dana * 86400;
    var sati = Math.floor(delta / 3600) % 24;
    delta -= sati * 3600;
    var minute = Math.floor(delta / 60) % 60;
    delta -= minute * 60;
    var sekunde = Math.floor(delta % 60);

    var formatDana = function (i) {
      return i > 1 ? "dana" : "dan";
    }
    var formatSata = function (i) {
      return i > 4 ? "sati" : "sata";
    }

    if (dana > 0)
      return dana + " " + formatDana(dana) + " i " + sati + " " + formatSata(sati);
    else
      return sati + " " + formatSata(sati) + " i " + minute + " minuta";
  }


  render() {

    var user = this.props.user;
    var state1 = {};
    if (user) {
      var ponuda = user.promocije.availableItems.length > 0 && user.promocije.availableItems[user.promocije.availableItems.length - 1];
      var aktivno = !ponuda && user.promocije.runningItems.length > 0 && user.promocije.runningItems[user.promocije.runningItems.length - 1];

      var state1 = {
        dostupanBonus: !!ponuda,
        aktivanBonus: !!aktivno,
        bonusPostotak: !!aktivno ? Math.round(aktivno.iznosIsplaceno / aktivno.iznos * 100) : 0,
        iznosBonusa: !!aktivno ? aktivno.iznos : 0,
        bonusKuna: !!aktivno ? aktivno.iznosIsplaceno : 0,
        zaIsplatu: !!aktivno ? aktivno.zaIsplatu : false,
        brojBodova: !!aktivno ? aktivno.brojBodova : 0,
        maxBodova: !!aktivno ? aktivno.maxBodova : 0,
        dostupanBonusActive: !!aktivno ? (new Date(aktivno.datumZavrsetka) > new Date() && aktivno.active) : false,
        minDeposit: !!aktivno ? aktivno.minDeposit : !!ponuda ? ponuda.minDeposit : 0,
        maxDeposit: !!aktivno ? aktivno.maxDeposit : !!ponuda ? ponuda.maxDeposit : 0,
        datumZavrsetka: !!aktivno ? new Date(aktivno.datumZavrsetka) : new Date(),
        trajanjePromocije: !!aktivno ? aktivno.trajanjePromocije : !!ponuda ? ponuda.trajanjePromocije : 0,
      };
    }



    return <div>
      <MetaTags title="Bonusi - SuperSport CASINO" description="Casino reload u SuperSport CASINU!" />
      <Header key="header" {...this.state} {...this.props} />
      <div className="white-background">
        <div className="banner " style={{ height: '233px' }}>
          <section className="casino-reload banner--inner selected">
            <div className="banner--content">
              <div className="banner--bg-container">
                <div className="banner--repeater" />
                <div className="banner--background" />
                {/* <div className="banner--mask-white" style={{bottom: '-20px'}} />  */}
              </div>
              <div className="banner--foreground">
                <div className="banner--image">
                  <div className="banner--text" />
                </div>

              </div>
            </div>

          </section>

        </div>

        <div
          id="page-wrapper"
          className="max-width-70 margin-center no-padding-on-mobile "
        >

          <div className="padding-sides-medium-2 border-top-small white-background">
            <h2 className="v4 margin-bottom-small">Casino Reload Bonus</h2>
              Casino Reload je bonus skrojen baš za Vas. Prilikom uplate (prebacivanja) sredstava na casino/poker račun aktivirajte „Casino reload bonus“ i osvojite do
                  <b> 100% iznosa uplate</b>.  <br /><br />
          </div>

          <div className=" break-page tablet-hidden" />


          {(state1.aktivanBonus || state1.dostupanBonus) &&
            <div
              className="padding-sides-medium-2 "
              style={{ backgroundColor: '#36414a' }}              >

              <h2 className="v6 ">Moj napredak bonusa

                 {!state1.aktivanBonus && <NavLink className="reload-uplati-btn" to={{
                  pathname: this.props.getHomePathFn(this.props.route.location, '/account'),
                  state: { showNaCasino: true }
                }}>Uplati</NavLink>}
              </h2>

              <div style={{ height: '35px' }}>
                {!state1.aktivanBonus && <NavLink to={{
                  pathname: this.props.getHomePathFn(this.props.route.location, '/account'),
                  state: { showNaCasino: true }
                }}>
                  <div
                    className="text-white text-color-1"
                    style={{ fontSize: '14px', lineHeight: '35px' }}                      >
                    <div style={{ display: 'inline-block', }}> Potrebna je uplata na casino račun   </div>
                  </div>
                </NavLink>}
              </div>

              <div className="progress-bar v2">
                <div className="bar">
                  {/* {!state1.aktivanBonus &&
                      <div className="bar--progress" style={{ width: '3%' }} />} */}
                  {state1.aktivanBonus &&
                    <div
                      className="bar--progress"
                      style={{ width: state1.bonusPostotak + '%' }}
                    />}
                  <div className="bar--lines">
                    {(state1.bonusPostotak != 5) && <div className="line" style={{ width: '5%' }}></div>}
                    {(state1.bonusPostotak != 10) && <div className="line" style={{ width: '10%' }}></div>}
                    {(state1.bonusPostotak != 15) && <div className="line" style={{ width: '15%' }}></div>}
                    {(state1.bonusPostotak != 20) && <div className="line" style={{ width: '20%' }}></div>}
                    {(state1.bonusPostotak != 25) && <div className="line" style={{ width: '25%' }}></div>}
                    {(state1.bonusPostotak != 30) && <div className="line" style={{ width: '30%' }}></div>}
                    {(state1.bonusPostotak != 35) && <div className="line" style={{ width: '35%' }}></div>}
                    {(state1.bonusPostotak != 40) && <div className="line" style={{ width: '40%' }}></div>}
                    {(state1.bonusPostotak != 45) && <div className="line" style={{ width: '45%' }}></div>}
                    {(state1.bonusPostotak != 50) && <div className="line" style={{ width: '50%' }}></div>}
                    {(state1.bonusPostotak != 55) && <div className="line" style={{ width: '55%' }}></div>}
                    {(state1.bonusPostotak != 60) && <div className="line" style={{ width: '60%' }}></div>}
                    {(state1.bonusPostotak != 65) && <div className="line" style={{ width: '65%' }}></div>}
                    {(state1.bonusPostotak != 70) && <div className="line" style={{ width: '70%' }}></div>}
                    {(state1.bonusPostotak != 75) && <div className="line" style={{ width: '75%' }}></div>}
                    {(state1.bonusPostotak != 80) && <div className="line" style={{ width: '80%' }}></div>}
                    {(state1.bonusPostotak != 85) && <div className="line" style={{ width: '85%' }}></div>}
                    {(state1.bonusPostotak != 90) && <div className="line" style={{ width: '90%' }}></div>}
                    {(state1.bonusPostotak != 95) && <div className="line" style={{ width: '95%' }}></div>}
                  </div>
                </div>
                {state1.aktivanBonus &&
                  state1.bonusPostotak <= 60 &&
                  <div
                    className={
                      'iznos-desni' +
                      (state1.bonusPostotak < 0.5 ? ' no-border' : '')
                    }
                    style={{ left: state1.bonusPostotak + '%' }}
                  >
                    {state1.bonusPostotak < 30 &&
                      <span className="text-18 text">Osvojenih </span>}
                    {casino.utils.numberToKune(state1.bonusKuna)}
                  </div>}
                {state1.aktivanBonus &&
                  state1.bonusPostotak > 60 &&
                  <div
                    className={
                      'iznos-lijevi' +
                      (state1.bonusPostotak > 99.5 ? ' no-border' : '')
                    }
                    style={{ right: 100 - state1.bonusPostotak + '%' }}
                  >
                    {state1.bonusPostotak > 70 &&
                                <span className="text-18 text">Osvojenih </span>}
                            {casino.utils.switchKnToEur(state1.bonusKuna) + ' ' + casino.utils.switchCurrencyKnToEur()}
                  </div>}
              </div>
              {state1.aktivanBonus &&
                <div>
                  <div className="text-right" style={{ borderRight: '1px solid rgba(181, 206, 227, .5)', paddingRight: '5px', paddingTop: '1px', marginTop: '4px', }}>
                            <span className="text-right  text-16 text relative" style={{ bottom: '-4px' }}                      >
                                Maksimalno        {casino.utils.switchKnToEur(state1.iznosBonusa) + ' ' + casino.utils.switchCurrencyKnToEur()}                    </span>
                  </div>

                  <div className="text-left text-17 text" style={{ marginBottom: '0px', marginTop: '15px' }}                    >

                    <div className="text-left text-171 text" style={{ paddingBottom: '5px', marginTop: '0px' }}>
                      {state1.zaIsplatu && <div>Čeka se isplata Reload-a!</div>}
                      {!state1.zaIsplatu && !state1.dostupanBonusActive && <div>Promocija je završila!</div>}
                      {!state1.zaIsplatu && state1.dostupanBonusActive && <div>Još {state1.brojBodova <= 2 && <span>samo</span>} <span className="text-white"><span className="semi-bold"> {state1.brojBodova} bodova </span></span>do sljedećeg Reload-a!</div>}
                    </div>
                    <div style={{ paddingBottom: '12px', marginTop: '0px' }}>
                      <span className=" text-17 text">Do isteka još: </span>
                      <span className="text-white">
                        <span className="semi-bold">
                          {this.getTime(
                            state1.datumZavrsetka,
                            state1.dostupanBonusActive
                          )}
                        </span>
                      </span>
                    </div>
                  </div>
                  {/* <div className="text-left text-17 text" style={{ paddingBottom: '12px', marginTop: '0px' }}>
                      Maksimalno bodova: <span className="text-white"><span className="semi-bold"> {state1.maxBodova}</span></span>
                    </div> */}

                </div>}

              {!state1.aktivanBonus && <br />}

              <div className=" break-page tablet-hidden" />

            </div>}
          <div className="mobile-hidden"><br /></div>

          <div className="padding-sides-medium-2 border-top-small white-background">

            <div className="segment v2">
              {this.state.tabs &&
                this.state.tabs.map(tab => (
                  <button
                    key={tab}
                    onClick={() => this.gotoTab(tab)}
                    className={
                      'segment--btn' +
                      (this.state.selectedTab === tab ? ' selected' : '')
                    }
                  >
                    <span>{tab}</span>
                  </button>
                ))}
            </div>
          </div>

          {this.state.selectedTab == 'Casino Reload Bonus' &&
            <div>
              <div className="padding-sides-medium-2 max-width-70   ">
                <br />
                {(!state1.aktivanBonus && state1.dostupanBonus) &&
                  <div>
                    {/* dostupan bonus */}

                      Casino reload bonus je bonus koji krojite sami. <br></br><br></br>
                      Prilikom uplate (prebacivanja) sredstava na casino/poker račun aktivirajte <b>„Casino Reload Bonus“</b> čime dobivate mogućnost da osvojite do <b>100% iznosa uplate.</b>
                    {' '}Iznos bonusa  jednak je iznosu uplate prilikom koje ste označili da želite bonus ali ne više od maksimalnog iznosa bonusa.
                            <br></br><br></br>
                            Najmanji iznos uplate prilikom koje možete  odabrati da želite bonus je {casino.utils.switchKnToEur(state1.minDeposit) + ' ' + casino.utils.switchCurrencyKnToEur()} a najveći iznos je<b> {casino.utils.switchKnToEur(state1.maxDeposit) + ' ' + casino.utils.switchCurrencyKnToEur()}.</b>
                    <br></br><br></br>Nakon aktivacije imate {state1.trajanjePromocije} dana da „oslobodite“ bonus osvajanjem bodova.
                      Bodovi se osvajaju igranjem igara sukladno popisu sa strane.
                      Bonus se isplaćuje na račun, u obrocima od <b>5% od ukupnog bonusa.</b>
                    <br></br><br></br> U periodu trajanja <b>„Casino Reload Bonusa“</b> navedeni se može aktivirati samo jednom, odabirom u trenutku prebacivanja sredstava s glavnog/sport računa na casino/poker račun.

                  </div>
                }


                {(state1.aktivanBonus && state1.dostupanBonusActive) &&
                  <div>
                    {/* bonus aktivan */}
                      Čestitamo, prihvatili ste    <b>„Casino Reload Bonus“ promociju</b>.
                      <br></br><br></br>  Aktivirali ste je u iznosu od <b>{casino.utils.numberToKune(state1.iznosBonusa)}.</b>
                      Od trenutka  aktivacije imate {state1.trajanjePromocije} dana da „oslobodite“ bonus osvajanjem bodova što znači da vam je još preostalo {this.getTime(state1.datumZavrsetka, true)}.

                      <br></br><br></br>Bodovi se osvajaju igranjem igara navedenih u popisu "Gdje mogu pronaći bodove", sukladno pravilima "Casino reload bonusa". Do sada ste osvojili {casino.utils.numberToKune(state1.bonusKuna)}, a do slijedećeg reloada potrebno je osvojiti još {state1.brojBodova} bodova.
                      Bonus se isplaćuje na casino/poker račun u obrocima od 5%. <br></br><br></br>
                      Vaše je samo da igrate. <br></br><br></br>
                      Bonus se isplaćuje u roku od nekoliko minuta a najkasnije slijedećeg radnog dana.


                  </div>
                }


                {(state1.aktivanBonus && !state1.dostupanBonusActive && state1.iznosBonusa != state1.bonusKuna) &&
                  <div>
                    {/* neaktivan bonus - istek */}
                    <b>„Casino Reload Bonus“ je završen.</b>
                    <br></br><br></br>
                      Osvojili ste ukupno {casino.utils.numberToKune(state1.bonusKuna)} od {casino.utils.numberToKune(state1.iznosBonusa)}.
                      {' '}Nažalost propustili ste priliku da osvojite još {casino.utils.numberToKune(state1.iznosBonusa - state1.bonusKuna)}.  <br></br><br></br>
                    <b>Igrajte i dalje i više sreće u drugim bonus iznenađenjima koje pripremamo za Vas.</b>


                  </div>
                }

                {(state1.aktivanBonus && !state1.dostupanBonusActive && state1.iznosBonusa == state1.bonusKuna) &&
                  <div>
                    {/* neaktivan bonus - ispunjeno */}
                      Čestitamo, uspješno ste završili  <b>„Casino Reload Bonus“.</b><br></br><br></br>
                      Osvojili ste ukupno {casino.utils.numberToKune(state1.bonusKuna)}.<br></br><br></br>
                    <b>Igrajte i dalje i puno sreće u novim Bonus iznenađenjima koje pripremamo za Vas.</b>


                  </div>
                }


                {/* <h2 className="v4 margin-bottom-small margin-top padding-sides-medium-2  ">
                  Pravila
                </h2>
                <div className="padding-sides-medium-2 max-width-70   ">
                  Casino Reload je bonus skrojen baš za Vas. <br></br><br />Prilikom uplate (prebacivanja) sredstava na casino/poker račun aktivirajte „Casino reload bonus“ i osvojite do
                  <b> 100% iznosa uplate</b>.
                  <br /><br />
                  {state1.aktivanBonus && <span>  Promocija traje do <b>{casino.utils.dateToFullDateString(state1.datumZavrsetka)}. </b></span>}

                  {state1.dostupanBonus && <span> Minimalni iznos uplate prilikom koje možete aktivirati bonus je {casino.utils.numberToKune(state1.minDeposit)} a maksimalni iznos za koji možete osvojiti je
                    <b> {casino.utils.numberToKune(state1.maxDeposit)}.</b>   </span>}
                  <br />
                  <br />
                  {state1.dostupanBonus && <span>    Iznos bonusa jednak je iznosu uplate prilikom koje aktivirate bonus. Nakon aktivacije imate {state1.trajanjePromocije} dana da „oslobodite bonus“ osvajanjem bodova.</span>}
                  <h2 className="v4 margin-bottom-small margin-top ">
                    Trajanje
                  </h2>
                  U periodu trajanja Casino Reload Bonusa navedeni bonus možete aktivirati samo jednom, odabirom u trenutku prebacivanja novca s glavnog/sport računa na casino/poker račun. */}

                <br /><br />
              </div>
            </div>
          }

          {this.state.selectedTab == 'Bodovanje' &&
            <div className="margin-bottom">

                    <div className="padding-sides-medium-2 margin-top">
                        Bodove skupljate igranjem casino igara na način da za svakih odigranih <b>{casino.utils.switchKnToEur(25) + ' ' + casino.utils.switchCurrencyKnToEur()}</b> dobijete bodove prema donjoj tablici:
                  <table className="poker-reload-tabla">
                  <tbody>
                    <tr>
                      <td>
                        <img src="content/images/bonusi/casinoreload/ic-slotovi@3x.png" />
                      </td>
                      <td>Slotovi</td>
                      <td>1 bod</td>
                    </tr>
                    <tr>
                      <td>
                        <img src="content/images/bonusi/casinoreload/ic-videopokeri@3x.png" />
                      </td>
                      <td>Videopokeri</td>
                      <td>0,2 boda</td>
                    </tr>
                    <tr>
                      <td>
                        <img src="content/images/bonusi/casinoreload/ic-table-poker@3x.png" />
                      </td>
                      <td>Table poker</td>
                      <td>0,2 boda</td>
                    </tr>
                    <tr>
                      <td>
                        <img src="content/images/bonusi/casinoreload/ic-roulette@3x.png" />
                      </td>
                      <td>Roulette</td>
                      <td>0,2 boda</td>
                    </tr>
                    <tr>
                      <td>
                        <img src="content/images/bonusi/casinoreload/ic-hi-low@3x.png" />
                      </td>
                      <td>Hi/Lo</td>
                      <td>0,1 boda</td>
                    </tr>
                    <tr>
                      <td>
                        <img src="content/images/bonusi/casinoreload/ic-blackjack@3x.png" />
                      </td>
                      <td>Blackjack</td>
                      <td>0,1 bod</td>
                    </tr>
                    <tr>
                      <td>
                        <img src="content/images/bonusi/casinoreload/ic-baccarat@3x.png" />
                      </td>
                      <td>Baccarad</td>
                      <td>0,1 bod</td>
                    </tr>
                    <tr>
                      <td>
                        <img src="content/images/bonusi/casinoreload/ic-classic@3x.png" />
                      </td>
                      <td>Casino Classic</td>
                      <td>Ne ulazi u bonus</td>
                    </tr>
                    <tr>
                      <td>
                        <img src="content/images/bonusi/casinoreload/ic-poker@3x.png" />
                      </td>
                      <td>Poker</td>
                      <td>Ne ulazi u bonus</td>
                    </tr>
                  </tbody>
                </table>
              </div>
              <hr />
              <div className="padding-sides-medium-2 margin-top">
                Za detaljan popis igara provjerite pravila bonusa.
               </div>

            </div>}

          {this.state.selectedTab != 'Rezultati' &&
            <div className="text-center">
              <hr />
              <a className="btn medium fill gray blue margin-top margin-bottom no-text-transform"
                target="_blank"
                href="https://view.officeapps.live.com/op/embed.aspx?src=https://cdn.supersport.hr/casino/documents/pravila/CasinoReloadBonus.doc"                >
                <span>Pravila bonusa</span>
                <span className="icon ico-expand-outline" />
              </a>
            </div>}

        </div>
      </div>

      <ObavijestiCasino {...this.props} />
    </div>

  }
}
